
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#EAF8F9","cx":"30","cy":"30","r":"30"}}),_c('path',{attrs:{"d":"M17 48.302V11.107C17 9.944 17.943 9 19.106 9h21.37c1.162 0 2.105.944 2.105 2.107v37.195a2.106 2.106 0 01-2.106 2.106H19.106A2.106 2.106 0 0117 48.302","fill":"#FFD058"}}),_c('path',{attrs:{"fill":"#FFF4F2","d":"M19.79 39.652h20.001v-25.97H19.79z"}}),_c('path',{attrs:{"stroke":"#2475B7","stroke-width":".5","stroke-linejoin":"round","d":"M27.284 11.405h5.015"}}),_c('path',{attrs:{"d":"M27.176 45.03a2.615 2.615 0 115.23.002 2.615 2.615 0 01-5.23-.002M23.721 26.667a6.07 6.07 0 1112.14.002 6.07 6.07 0 01-12.14-.002","fill":"#2475B7"}}),_c('path',{attrs:{"stroke":"#FFF","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.444 26.516l2.333 2.332 4.36-4.361"}})])])
          )
        }
      }
    